import { EnvironmentProviders, inject, Provider, provideAppInitializer } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideAppInitializer(async () => {
      await inject(AuthService).initSession();
    }),
  ];
};
